(function ($) {
    // shorten references to variables. this is better for uglification var kendo = window.kendo,
    var ui = kendo.ui,
    	Widget = ui.Widget;

    var KontoGrid = Widget.extend({
        init: function(element, options) {
        	var that = this;

            // base call to widget initialization
            Widget.fn.init.call(this, element, options);
            
            that.element.addClass("konto-grid");
            
            if (typeof that.options.toolbar === 'function')
            	that.options.toolbar = that.options.toolbar();
            	
            that._postaviVrijednostiCheckboxova();
        	that._prepareCachedValues();
            
            // Settings je varijabla koju šaljemo u grid.
            var settings = $.extend(true, {}, this.options);
            settings.name = "Grid";
                        	
            var toolbar = settings.toolbar;
                                 
            //var settings = options;
            if (settings.colModel !== null) {
            	var columns = settings.colModel.columns;            	
            	settings.columns = $.extend(true, columns, settings.columns);
            	that.options.columns = settings.columns;
            }
                        
            if (settings.checkboxSelection) {				
	            settings.columns.unshift({
	            	title: "&nbsp;",
	            	field: "CHECKED",
	            	template: "<input type=\"checkbox\" class=\"row-checkbox\" />",
	            	filterable: false,
	            	sortable: false,
	            	width: "2.2em"
	            });
            }
            
            //postavljam na false, ako nešto ima vratit će se na true
			this.options.remember.columns = false; 
			settings.remember.columns = false;
            
            //provjera cache za redosljed kolona, ako imamo spremljeno prepisujemo
            var cache = that.options.selValues;
            if (typeof cache === "object") {
				if ((typeof cache.grid === "object")) {
					if ((typeof cache.grid.columns === "object")) {
            			var columns = cache.grid.columns;            	
            			settings.columns = cache.grid.columns;
						that.options.columns = cache.grid.columns;
						that.options.reorderTitle = cache.grid.reorderTitle;
						
						settings.remember.columns = true;
						this.options.remember.columns = true;
					}	
				}		
			}
			
            
            // U slučaju da mi nije zadan datasource kreiram ga sam.
            if (settings.dataSource == null) {
            	settings.dataSource = that._createDataSource(settings);
            	settings.pageable.pageSize = settings.dataSource.pageSize;
            }

           	settings.dataBound = that._getDataBoundFunction(settings);
            
            var noToolbar = settings.noToolbar; // Ipak ne zbog settings dropdown-a.  //|| !settings.toolbar || settings.toolbar.length == 0;
            if (noToolbar) {
            	settings.toolbar = "";
            	settings.toolbarFiltering = false;
            	settings.sortable = settings.localData;
            }
            else 
            	settings.toolbar = " ";
                    
            // Kreiranje grida
            var _grid = $("<div style=\"width: 100%;\"></div>");
            that.element.append(_grid);
            that._noviObjectUDataSource(that, settings);
            that.grid = _grid.kendoGrid(settings).data("kendoGrid");

            that.grid.toolbar = toolbar;
            that.filterAutomatskiPostavljen = false;
            var selValues = options.selValues || {};
	    	var gridValues = selValues.grid || {};
            if (gridValues.fullRow){
            	that.grid.fullRow = gridValues.fullRow;
            }else{
            	that.grid.fullRow = false;	
            }
            	
            that.grid.dataSource.bind("change", function (e) {
            	var filter = this.filter();
            	if (filter) {            		
            		that._postaviFilterToolbar(filter);
    				$("input.konto-check-all").prop("checked", false);
            	}
            	else {
            		that._clearFilterToolbar();
            	}            	            	
            });
            
            if (that.grid !== null) {
                that.grid.element.find(".k-grid-header table").on("click", ".konto-filter-row th", function (e) {
                	var el = $(this).find("input");
                	if(el.hasClass("konto-check-all")){
                		el.focus();
                	}
                	else {            	
	                	if(that.filterAutomatskiPostavljen) {
	                		el.focus();	
	                		that.filterAutomatskiPostavljen = false;
	                	}
	                	else {
	                		el.click();
	                	}
                	}
                });
                
                that.grid.element.find(".k-grid-header table").on("click", ".konto-toolbar-filter input", function () {            	
                    that._automatskoPostavljanjeFiltera(this);
            		that.filterAutomatskiPostavljen = true;
            		if (this !== document.activeElement)
                    	$(this).select();                 
                });
                
            	that.grid.element.find(".k-grid-header table").on("click", ".konto-toolbar-filter", function () {
            		that._focusFilterInput();
            	});
            	
            	that.grid.element.find(".k-grid-header table").bind("keydown", function (event) {
            		that._focusFilterInput();
            	});
            	
            	that.grid.element.find(".k-grid-content table").on("contextmenu", "tbody td", function(e) {
                    that._selectRowWithActiveCell(that);
            	});
            	
            	that.grid.element.find(".k-grid-content table").on("click", "[class*='-row-checkbox']", function(e) {
					var cell = $(e.currentTarget);
					var selektiraniRedak = that.grid.select();
					var najbliziRedak = cell.closest('tr');
					if (najbliziRedak != selektiraniRedak){
						that.grid.select(najbliziRedak);
						that.grid.trigger("change");	
					} 
				});
            	
			    that.grid.element.find(".k-grid-content table").on("click", "tbody td", function(e) {
			    	var klasa = $(this).prop("class");
					if (klasa != "k-detail-cell") //ovo je da u master-detailu ne fokusira detail
					{
			      		var cell = $(e.currentTarget);
						that.grid.current(cell);

						//dorada za checkbox da se prilikom oznake selektira redak.
						if (settings.checkboxSelection){
							var selektiraniRedak = that.grid.select();
							var najbliziRedak = cell.closest('tr');
							if (najbliziRedak != selektiraniRedak){
								that.grid.select(najbliziRedak);
								that.grid.trigger("change");	
							}  
						}

					}
			    });
            	
                that.grid.table.bind("keydown", function (event) {
                    if (event.which === 38 || event.which === 40 || 
                    	(settings.useLeftRightKeys == true && (event.which === 37 || event.which === 39))) {
                    	that._focusFilterInput();     
                        that._selectRowWithActiveCell(that);
                    }
                });
                
                if (that.grid.lockedTable){
	                that.grid.lockedTable.bind("keydown", function (event) {
	                    if (event.which === 38 || event.which === 40 || 
	                    	(settings.useLeftRightKeys == true && (event.which === 37 || event.which === 39))) {

	                    	that._focusFilterInput();
	                        var dataRows = that.grid.lockedTable.children().last().children();
	                        num = -1;
	                        dataRows.each(function () {
	                            num++;
	                            
	                            $("td", $(this)).each(function () {                           	
	                                if ( $(this).attr("id") == "aria_active_cell" ) {
	                                    var row = that.grid.lockedTable.children().last().find("tr").eq(num);
	                                    that.grid.select(row);
	                                    that.grid.trigger("change");
	                                }
	                            });
	                        });
	                    }
	                });
                }
                
            }
            
            if (that.grid && that.grid.pager) {
                that._initPager();
            }
            
            //U novoj verziji kenda postoji toolbarfiletering ali nije baš pogodan za nas (za njega moraju biti jako široke kolone), 
            //resiza grida to je uvijek upaljeno i ako ne želimo onda moramo maknuti ručno
            /*
            if (settings.toolbarFiltering) {
            	// U novoj verziji Kenda (2014 Q2) postoji toolbar filtering mogućnost.
            	that._createToolbarFilterPanel();
            }else{
				that._removeToolbarFilterPanel();	
			}
			*/
			that._kontoToolbarFiltering();
            // Zbog čega je ovo bilo u dataBound()?
            that._createToolbar();
            that._postaviDivAfterToolbar();
            that._postaviTitle();
            that._postaviDivAfterContent();
            that._bindEvents();
            
            if (settings.rightMenu) {
                that._kreirajDesniIzbornik(settings.rightMenu, false);
                if (that.grid.lockedContent)
                	that._kreirajDesniIzbornik(settings.rightMenu, true);   
            }                                  
            
            that._obojajDropdownFiltere();
            
            // Fokusiranje grida.
            that.focus();
        },
        _noviObjectUDataSource: function(that, settings){
            if (settings.noviObject){
                var dataItem = settings.noviObject;
                var keyFields = settings.keyFields;
                var columnValues = {};
                if (dataItem) {
                    for (var i = 0; i < keyFields.length; ++i) {
                        var column = keyFields[i];
                        var val = dataItem[column];
                        if (typeof val == 'object'){
                            try{
                                val = KUtils.formatDate(val);     
                            } catch (e) {  } 
                        }
                        columnValues[column] = val;
                    }
                } 
                try{
                    settings.dataSource.transport.read.data.selValues = columnValues;     
                } catch (e) {  }                    
            }
        },
        _selectRowWithActiveCell: function(that){
            var dataRows = that.grid.tbody.children();
            num = -1;
            setTimeout(function(){ 
                dataRows.each(function () {
                    num++;                   
                    $("td", $(this)).each(function () {                              
                        if ( $(this).attr("id") == "aria_active_cell" ) {
                            var row = that.grid.tbody.find("tr").eq(num);
                            that.grid.select(row);
                            that.grid.trigger("change");
                        }
                    });
                });
            }, 25);  
        },        
        _bindEvents: function () {
        	var that = this;
        	if (that.options.rowDblClick) {
        		// IE9 ne radi
        		/*
        		that.grid.tbody.on("dblclick", ">tr", null, function (e) {
        			var dataItem = that.grid.dataItem(this);
        			that.options.rowDblClick.call(that, dataItem, e);
        		});
        		*/
        		
        		// Ovo radi i za IE9. Treba delegata bindati na element iznad - table.
        		// Ne znam razlog zbog kojih bindanje na tbody ne radi.
        		that.grid.element.on("dblclick", "tbody > tr", function (e) {
        			var dataItem = that.grid.dataItem(this);
        			that.options.rowDblClick.call(that, dataItem, e);
        		});
        	}
        	
        	if (that.grid && that.grid.pager) {
        	    //klik na stranicu briše selValues jer se u suprotnom vrati na stranicu na kojoj je selektirani slog
               var pagesEl = that.element.find("div.k-pager-numbers");
               pagesEl.click(function (event) {
                    try{
                        that.grid.dataSource.transport.options.read.data.selValues = null;     
                    } catch (e) {  }                   
               });
               
                //ovo je za male ekrane + respozivni design
               	var pagesSel = that.element.find("div.k-pager-numbers-wrap").find('select');
               	pagesSel.on("change", function (event) {
                    try{
                        that.grid.dataSource.transport.options.read.data.selValues = null;     
                    } catch (e) {  }  
               	});

            }
            
            //prljavi hax jer u novom kendu se change ne okine kad je upaljen "checkboxSelection"
            if (that.grid.options.checkboxSelection == true){
				that.grid.bind("changing", function (e) {		
					that.grid.trigger("change");
				});
			}
        	
        	that.grid.bind("change", function (e) {
    			var sel = this.select();
    			if ((sel.length == 1) || ((sel.length == 2) && (that.grid.dataItem(sel[0]) == that.grid.dataItem(sel[1])))){
    				var redak = sel[0];
					var dataItem = that.grid.dataItem(redak);
					
					if (that.options.onRowSelected)
						that.options.onRowSelected(dataItem, e);
					
					//automatsko prosirivanje retka na klik
					if (that.options.fullRowHeightOnClick) {
						if ($(redak).hasClass('showLargeCell')) {
							$(redak).removeClass('showLargeCell');
						} else {
							$(redak).parent().find('tr').removeClass('showLargeCell');
							$(redak).addClass('showLargeCell');
						}
					}
    			}
			});									
        },
        _automatskoPostavljanjeFiltera: function(el) {
				var kp = KUtils.getKorisnikPostavke();
				if(kp.automatskoPopunjavanjeFiltera && (!(el === document.activeElement))){			        		
        		    var element = $(el);      
        		    var old_value = element.val();
        		   
        		    if(kp.automatskiPrijepisVrijednostiFiltera || (old_value === ''))
        		    {	
	        			var grid = element.parents("div.konto-grid").first();             			        			        			
	        			var field_name = element.closest("th.k-header.konto-toolbar-filter").data("field");
	        			
	        			
	        			//var data_index = grid.find("[data-field=" + field_name + "]").data("index");
						var data_index = null;
						for (i = 0; i < this.grid.columns.length; i++){
							if (this.grid.columns[i].field == field_name){
								data_index = i;
							}
						}
	        			  	        				        		
	        			var first_row = $(grid.find("tbody").prop("role","rowgroup").find("tr").first());      			
	        			
    		    		var master_row = first_row.hasClass("k-master-row");		        			  	
        			  	if (master_row) {
	        				var selected_row = $(grid.find("tr.k-master-row.k-selected"));        			  		
        			  	}	
        			  	else {
        			  		var selected_row = $(grid.find("tr.k-selected"));  	
        			  	}		
						
						if (data_index != null){
							var filter_field = $(selected_row.find("td")[data_index]);
							var filter_value = filter_field.html(); 
		        			
		        			if (filter_value) {
		        				filter_value = filter_value.substring(0,99);
		        				filter_value = filter_value.replace(/[\n\r]/g, '%');
			        			if (filter_value.search("<") != -1) {
			        				var d = $("<div/>").html(filter_value);		        				
			        				element.val(d.text().trim());        				
			        			}
			        			else {
			        				element.val(filter_value);
			        			}	
		        			} 
	        			}      			         			      			        		    
        		    }
        		}       	
        },
        _initPager: function () {
            var that = this;
            
            var refreshEl = that.element.find(".k-grid-pager .k-pager-refresh");
            refreshEl.click(function (event) {
                // Spremam objekt zbog pozicije.
                if (that.options.noviObject == null) {
                    that.options.noviObject = that.getSelectedData();
                    that.options.noviObjectNotExistAction = "ignore";
                }
            });

            var pagerNav = that.element.find(".k-pager-nav");
            pagerNav.click(function (event) {
                try{
                    that.grid.dataSource.transport.options.read.data.selValues = null;     
                } catch (e) {  }                 
            });

        },
        _getDataBoundFunction: function(settings) {
	    	var custom = settings.dataBound;
	    	var that = this;
	    	
	    	return function (e) { 		    		
	    		if (!that.grid) 
	    			that.grid = this;
	    		    	
	    		that._onDataBound.call(that, e); 
	    		if (typeof custom === "function")
	    			custom.call(this, e);
	    		
	    		// Pozivanje funkcije za svaki row.
	    		if (that.options.rowAdded) {
	    			var dataView = this.dataSource.view();
	    			for (var i = 0; i < dataView.length; ++i) {
	    				var data = dataView[i];
	    				var el = this.element.find("tbody tr[data-uid=" + data.uid + "]");
	    				that.options.rowAdded.call(that, data, el);
	    			}
	    		}
	    	};
	    },
	    _handleEditingFunction: function(settings) {
	    
	    },
	    
	    _updateSortFilterDeleteBtns: function() { 
	    	var gridSorts = this.grid.dataSource.sort();
	    	var gridFilters = this.grid.dataSource.filter();
	    	var btnBrisiSort = this.element.find('button.btn-obrisi-sortiranja');
	    	var btnBrisiFilter = this.element.find('button.btn-obrisi-filtere');
	    	var btnBrisiReorder = this.element.find('button.btn-obrisi-reorder');						 
	  
	    	var operatori = {		
				eq: "jednako",
				neq: "nije jednako",
				startswith: "počinje sa",
				contains: "sadrži",
				gte: "veći ili jednak",
				gt: "veći od",
				lte: "manji ili jednak",
				lt: "manji od"	    		
	    	};
	    	var logika = {
	    		and: "i",
	    		or: "ili"
	    	};
				    	
	    	// "obrisi sortiranja" gumb
	    	if (typeof gridSorts !== 'undefined' && !empty(gridSorts) && gridSorts.length > 0) {	
	    		var title = 'Obriši sortiranja: \n';
	    		$.each(gridSorts, function(key, val) {	
	    			title += val.field;
	    			if (val.dir == 'asc'){ 			
	    				title += '(uzlazno) \n';
	    			}else{
	    				title += '(silazno) \n';	
	    			}	  			
	    		});
    			btnBrisiSort.addClass('active-green');
    			btnBrisiSort.attr('title', title);
	    	} else {
	    		btnBrisiSort.removeClass('active-green');	
	    		btnBrisiSort.attr('title', 'Obriši sortiranja');    	
			}
			
			// "obrisi filtere" gumb
	    	if (gridFilters && gridFilters.filters.length > 0) {
	    		var title = 'Obriši filtere iznad stupaca: \n';
	    		
	    		// :)
	    		var rekurzija = function(data, logic) {
	    			var res = '';
	    			var first = true;
		    		$.each(data, function(key, val) {	    			
	    				if (!first)
	    					res += ' '+ logika[logic]+ ' ';	    					
		    			if (isset(val['logic'])) {
		    				res += '('+ rekurzija(val['filters'], val['logic']) +')';
		    			} else {
		    				res += val.field+ ' '+ operatori[val.operator]+ ' "'+ val.value+'"';    								
		    			}	
		    			
		    			first = false;		
		    		});
		    		return res;
	    		};
	    		
	    		title += rekurzija(gridFilters['filters'], gridFilters['logic']);
	    		
	    		btnBrisiFilter.addClass('active-green');
	    		btnBrisiFilter.attr('title', title);
	    	} else {
	    		btnBrisiFilter.removeClass('active-green');
	    		btnBrisiFilter.attr('title', 'Obriši filtere');
	    	} 
	    	
	    	if (this.grid.options.remember.columns  || this.options.remember.columns){
				btnBrisiReorder.addClass('active-green');
				btnBrisiReorder.attr('title', this.options.reorderTitle);
			}else{
				btnBrisiReorder.removeClass('active-green');
				btnBrisiReorder.attr('title', 'Obriši raspored stupaca');	
			}	
	    },
	    
	    _onDataBound: function() {
	        /**
	         * min-height grida je postavljen na 30px zato da se vidi progress
	         * kod inicijalnog učitavanja.
	         * Nakon toga, ako nema podataka, će se vidjeti samo bijela pozadina.
	         * To rješavamo postavljanjem min-height natrag na defaultnu vrijednost 0.
	         */
	        this.element.find(".k-grid-content").css("min-height", "0");
	        
	    	this._updateSortFilterDeleteBtns();
	    	
	    	var grid = this.grid;

	    	// Moguće je da ne postoje nikakvi podaci koje smo dobili od servera.
	    	// Postoji mogućnost da je to zbog toga jer smo u selValues imali neku staru stranicu (npr. 30) koje je vrijedila u nekim drugim okolnostima, 
	    	// a sad više ne postoji. U tom slučaju potrebnom je preusmjeriti se na stranicu 1 opet.
	    	// Kad nema ničeg, totalPages() vraća null. Zbog toga je potreban prvi uvjet da ne ode u infinite loop.
	    	if ((grid.dataSource.total() > 0) && (grid.dataSource.totalPages() < grid.dataSource.page())) {
	    		grid.dataSource.page(1);
	    		return;
	    	}
	    	
	    	// Premješteno: this._createToolbar();
	    	
	    	if (this.options.noviObject) {
	    		var obj = this.options.noviObject;
	    		var columns = {};
	    		if (this.options.keyFields) {
		    		for (var i = 0; i < grid.options.keyFields.length; ++i) {
		    			var key = grid.options.keyFields[i];
		    			if (obj[key])
		    				columns[key] = obj[key];
		    		}
		    		if (grid.options.selValues){
    		    		//u selValues stavljamo noviObjekt
    		    		try{
                            grid.options.selValues.grid.page = grid.dataSource.page();
                            grid.options.selValues.columns = columns;    
                        } catch (e) {  } 
		    		}
		    		if (!this._selectRow(columns)) {
		    		    var action = this.options.noviObjectNotExistAction;
		    		    this.options.noviObjectNotExistsAction = "";
		    		    // "ignore" akcija se koristi prilikom pritiska na refresh link (dolje u gridu).
		    		    // U tom slučaju čini mi se da nije potrebno filtrirati ako ne naiđemo na željeni redak.
		    		    if (action === "ignore") {
		    		        
		    		    }
		                else {
		                    /*  - za sad zakomentirano (kad se riješi pozicioniranje, ovo više ne bi smjelo biti moguće)
    		    			// Za sad odmah filtriram ako nije moguće naći redak u tabličnom prikazu.
    		    			try {
    							var ds = grid.dataSource;
    							var filter = {};
    							filter.logic = "and";
    							filter.filters = [];
    							$.each(columns, function (key, value) {
    								var f = {};
    								f.operator = "eq";
    								f.value = value;
    								f.field = key;
    								filter.filters.push(f);
    							});
    							ds.filter(filter);
    						} catch (e) { 
    							$.dialog({
    								title: "Pozicioniranje na redak",
    								content: "Filtriranje podataka nije uspjelo."
    							});
    						}
    						*/
    					}
		    		}
	    		}
	    		
	    		this.options.noviObject = null;
	    	}
            else if (this.options.selectLastRow){
	    		row = grid.tbody.find( "tr:last" );
	    		var lastRowData = grid.dataItem(row);
	    		this._selectRow(lastRowData);	    		
	    		this.options.selectLastRow = null;	
	    	}
            else if (grid.options.selValues && grid.options.selValues.columns) {
                this._selectRow(grid.options.selValues.columns);
            }
	    	else {
	    		// Selektiraj prvi red
	    		this._selectRow();
	    	}
	    },
	    
	    /**
	     * @param Object valuesToSelect 
	     * @param { bool | integer | jQuery Object } cell
	     * 		
	     * uputa za 'cell' varijablu:
	     * 	 
	     *  defaultno ponasanje:
	     *  	- ako je 'undefined', onda se postavlja vrijednost na nulu, odnosno
	     * 	 	selektirat ce se prva celija selektiranog retka
	     *
	     *  integer (indeks celije/polja u retku):
	     *	 	- grid.current se postavlja na poziciju zapisanu u 'cell' varijabli
	     *	
	     *  jQuery object (celije/polja):
	     *	 	- grid.current se postavlja na 'cell' objekt
	     *
	     *  bool (false):
	     *	 	- grid.current se postavlja na prvu poziciju prvog retka (defaultno Kendo ponasanje)
	     */
	    _selectRow:  function (valuesToSelect, cell) {
	    	var grid = this.grid;
	    	var data = grid.dataSource.data();
	    	var found = false;
	    	var dataItem = null;

	    	if (valuesToSelect) {
		    	for (var i = 0; i < data.length; ++i) {
		    		dataItem = data[i];
		    		found = true;
		    		$.each(valuesToSelect, function (key, value) {
		    			if (dataItem[key] != value){
		    				found = false;
			    			if ( (typeof dataItem[key] == "object") && (typeof value == "string") ){
			    				try{
									var dateStr	= KUtils.formatDate(dataItem[key]);
									if (dateStr == value)
										found = true;	
								} catch (e) { }
			    			}		    				
		    			}
		    		});
		    		if (found) {
		    			break;
		    		}
		    	}
	    	}
	    	var elements = grid.items();
	    	if (found) {
	    		var element = elements.filter("[data-uid=\"" + dataItem.uid + "\"]");
	    		grid.select(element);
	    		grid.trigger("change");
		    }
	    	else {
	    		if (elements && elements.length > 0) {
	    			var element = elements[0];
	    			grid.select(element);
	    			grid.trigger("change");
	    		}
	    	}
	    	
			//selektiranje polja
	    	this._selectCell(cell);
	    	
	    	return found;
	    },

	    /**
	     * @param Object valuesToSelect 
	     * @param { bool | integer | jQuery Object } cell
	     */	  
	       
	    _selectCell: function (cell) {
	    	var grid = this.grid;
	    	var cellObj = false;

	    	//staro defaultno ponasanje - prvi redak, prvo lijevo polje
	    	//(u slucaju da nam to treba, potrebno je samo proslijediti boolean u _selectRow za 'cell' varijablu)
	    	if (typeof cell === 'boolean') 
	    		return;
   	   	
	    	if (typeof cell === 'undefined' || typeof cell === 'number') {
	    		var selData = this.getSelectedData();
	    		
	    		if (!selData)
	    			return;
	    		
	    		var goFindFirstVisible = false;
	    		if (typeof cell === 'undefined') {
	    			var cell = 0;
	    			var goFindFirstVisible = true;
	    		}
	    			
	    		var rowEl = this.element.find("tbody tr[data-uid=" + this.getSelectedData().uid + "]");
				var cellObj = this.getCellByIndex(rowEl, cell);
				
				//u slucaju da je 'cell' undefined, pronalazimo prvo VIDLJIVO polje
				if (goFindFirstVisible && cellObj && !cellObj.is(':visible')) 
	    			for (var i=1; i < rowEl.find('td').length; i++) {
	    				cellObj = this.getCellByIndex(rowEl, i);
	    				if (cellObj.is(':visible')) 
	    					break;
	    			}

	    	} else if (typeof cell === 'object') {
	    		cellObj = cell;
	    	}
	    	
	    	if (cellObj) 
	    		grid.current(cellObj);
	    	
	    },
	    
	    
	    _findColumn: function (columnName) {
	    	var columns = this.options.columns;
	    	for (var i = 0; i < columns.length; ++i) {
	    		var col = columns[i];
	    		if (col.field == columnName) {
	    			return col;
	    		}
	    	}
	    	return null;
	    },
	    /**
	     * Ako je u kendo filteru vrijednost (filter.value) Date onda će se raditi toString pri slanju na datasnap. A to daje format tipa
	     * Mon Jul 07 2014 21:36:37 GMT+0200 (CEST)
	     * 
	     * Zato ovdje formatiramo datum. 
	     * 
	     * Datum može biti Date objekt odmah ili običan string. Ovisi o tome jesmo li ga upisali u našem filter toolbaru (onda je string pa ga treba 
	     * pretvarati) ili je upisan preko naprednog kendovog filtriranja (onda je Date objekt).
	     * */
	    _fixDates: function (filter) {
	    	if (typeof filter === "undefined") 
	    		return;
	    	if (filter == null)
	    		return;
	    	if (filter.logic) {
	    		for (var i = 0; i < filter.filters.length; ++i) {
	    			this._fixDates(filter.filters[i]);
	    		}
	    	}
	    	else {
	    		var col = this._findColumn(filter.field);
	    		if (col == null)
	    		    return;
	    		if (col.type == "datetime" || col.type == "date" || col.type == "time") {
	    			var d = filter.value;
	    			var parsed = null;
	    			if (!(d instanceof Date)) {    				 
	    				var func = col.type == "datetime" ? KUtils.parseDateTime : col.type == "time" ? KUtils.parseTime : KUtils.parseDate;
	    				if (d.length == 19){
	    					parsed = func(d); // parse
	    					var formatVal = KUtils.formatDateTime(parsed, true);
	    				}
	    				// oportunistički - u slučaju datetime možda smo napisali bez vremena
	    				if ((parsed == null) && (d.length == 10)){
	    					parsed = KUtils.parseDate(d);
	    					var formatVal = KUtils.formatDate(parsed); 	
	    				}else{
	    					var formatVal = filter.value;	
	    				}
	    			}else{
	    				var formatFunc = col.type == "datetime" ? function (d) { return KUtils.formatDateTime(d, true); } : col.type == "time" ? KUtils.formatTime : KUtils.formatDate;
		    			var formatVal = formatFunc(d);		
	    			}   				    			

		    		filter.value = formatVal;	  		
	    		}
	    	}
	    },
	    _prepareCachedValues: function () {
	        var that = this;
	        var usage = that.options.cacheUsage;
	        var cache = that.options.selValues;
	        
	        if (typeof cache === "object") {
	            if (usage.currentRecord === false) {
	               delete cache.columns;
	            }
	            if ((typeof cache.grid === "object")) {
	                if (usage.page === false) {
	                    delete cache.grid.page;
	                    delete cache.grid.pageSize; 
	                }
	                if (usage.sort === false) {
	                    delete cache.grid.sort;
	                }
	                if (usage.filter === false) {
	                    delete cache.grid.filters;
	                }
	                if (usage.fullRow === false) {
	                    delete cache.grid.fullRow;
	                }
	               	if (usage.columns === false) {
	                    delete cache.grid.columns;
	                    delete cache.grid.reorderTitle;
	                }	                
	            }
	        }
	    },

	    _createDataSource: function (options) {
	    	var that = this;
	    	var queryData = $.extend({}, {reqtype: "kendogrid"}, options.data);	    	
	    	var page = 1; 
	    	var selValues = options.selValues || {};	    
	    	if (selValues.columns){	    	
	    	  queryData.selValues = selValues.columns;
	    	  //queryData.keyFields = options.keyFields;
	    	}
	    	
	    	var gridValues = selValues.grid || {};
	    	if (gridValues.page)
	    		page = gridValues.page;
	    	var pageSize = 10;
	    	if (gridValues.pageSize)
	    		pageSize = gridValues.pageSize;
	    	var gridEl = this;
	    	
    	   	var ds = {
		    	serverPaging: !options.localData,
				serverFiltering: !options.localData,
				serverSorting: !options.localData,
				transport: {
					
					read: {
						url: options.url,
						dataType: "json",
						data: queryData
						//global: false // Ne želim defaultni ajaxError ovdje
					},
					parameterMap: function (data, type) {
						if (type == "read") {
							that._fixDates(data.filter);
						}
						return data;
					}
				},
				schema: {
					total: function (response) {
						return response.total;
					}, 
					data: function (response) {
						// U response može biti filename ako smo pozvali export
						if (response.filename) {
							return response.filename;
						}
						
						that.options.datasnapResponse.call(that, response);
						
						var data = response.rows;
						if (data == null)
							return;

						if (response.page) {
							var page = parseInt(response.page);
							if (page != gridEl.grid.dataSource.page()) {
								gridEl.grid.dataSource.page(page);
							}
							//gridEl.grid.dataSource.page(response.page);
						}
						
						if (response.selValues){
						  //nešto   
						}
						
						return KUtils.normalizirajData(data);

					},
					model: {
						fields: options.colModel.model
					}
				},
				page: page,
				pageSize: pageSize,
				error: function (e) {
				}
	    	};
	    
	    	if (gridValues.filters)
	    		ds.filter = options.selValues.grid.filters;
	    	if (options.filters)
	    		ds.filter = options.filters;
	    	if (gridValues.sort)
	    		ds.sort = gridValues.sort;
	    	
	    	if (options.group)
	    		ds.group = options.group;
	    		
			if (options.aggregate)
	    		ds.aggregate = options.aggregate;	    		
                
	    	return ds;
	    },
	    _obojajDropdownFiltere: function(){
	       var tool = this.options.toolbar;  
	       	if (tool){  
                for (var i = 0; i < tool.length; ++i) {
                    var itemT = tool[i]; 
                    if (itemT && itemT.brojacAktivnih != undefined){
                        $('#'+ itemT.id).setBtnSucces(itemT.brojacAktivnih>0);    
                    }
                }
           }
	    },
	    /**
	     * 
	     * Za filtere (checkboxovi) je malo problematična situacija jer kod kreiranja
         * grida se mora zadati checked property od checkboxa te još i data property.
         * 
         * Trebao se kreirati i click event. Ova funkcija je rješenje tog problema. 
         * 
         * */
	    _postaviVrijednostiCheckboxova: function (items, dropItem) {
	    	var that = this;
	    	
	    	var toolbar = items || that.options.toolbar;

	    	if (toolbar) {
	    		if (!that.options.data) {
	    			that.options.data = {};
	    		}
	    		
	    		for (var i = 0; i < toolbar.length; ++i) {
	    			var item = toolbar[i];
	    			if (item.type && item.type == "checkbox") {
	    				if (item.dataField && (typeof that.options.data[item.dataField] === "undefined")) {
	    				    if (item.dataValueChecked === undefined){
	    				       that.options.data[item.dataField] = item.checked;   
	    				    }else{
				                if (item.checked){
                                  that.options.data[item.dataField] = item.dataValueChecked;   
                                }else{
                                  that.options.data[item.dataField] = item.dataValueUnChecked;   
                                } 
	    				    } 
	    				    if ((dropItem != undefined) && (item.checked)){ 
	    				        dropItem.brojacAktivnih++;	    				         
	    				    }
	    				    
	    				}
	    				if (typeof item.click === "undefined") {
                           
	    					item.click = (function () {
	    					    var dataField = item.dataField;
	    					    var dataValueChecked = item.dataValueChecked;
	    					    var dataValueUnChecked = item.dataValueUnChecked;
	    					    return function () {
	    					        if (item.dataValueChecked === undefined){
	    					          that.setAjaxOption(dataField, this.checked);	    					            
	    					        }else{
	    					            if (this.checked){
	    					              that.setAjaxOption(dataField, dataValueChecked);    
	    					            }else{
	    					              that.setAjaxOption(dataField, dataValueUnChecked);   
	    					            }	    					              
	    					        }
	    					        if (dropItem != undefined){ 
	    					            if (this.checked){
	    					              dropItem.brojacAktivnih++;    
	    					            }else{
	    					              dropItem.brojacAktivnih--;    
	    					            }
	    					          $('#'+dropItem.id).setBtnSucces(dropItem.brojacAktivnih>0);   
	    					        }
                                    // Probam se pozicionirati na redak, ali ako ne uspijem ne filtriram po ID-u.
                                    that.options.noviObjectNotExistAction = "ignore";
                                    that.refresh();                                    
                                };
	    					}) ();
	    				}
	    			}
	    				    			
	    			if ($.isArray(item.items)) {
	    			    if ((item.type && item.type == "dropdown") && (item.bojanjeAkoImaAktivnih) ){
	    			        item.brojacAktivnih = 0;
	    			        that._postaviVrijednostiCheckboxova(item.items, item);    
	    			    }else{
	    			        that._postaviVrijednostiCheckboxova(item.items);
	    			    }
	    			}
	    		}
	    	}
	    },
	    //fix je potreban gdje se koristi setUrl funkcija
	    _kontoToolbarFiltering: function(){
            if (this.options.toolbarFiltering) {
            	// U novoj verziji Kenda (2014 Q2) postoji toolbar filtering mogućnost.
            	this._createToolbarFilterPanel();
            }else{
				this._removeToolbarFilterPanel();	
			}	
		},
	    _createToolbarFilterPanel: function () {
	    	var that = this;
	    	var grid = that.grid;
			var toolbarHtml = "";
			var gridColumns = grid.thead.find("tr th");
			var colIndex = 0;
			for (var i = 0; i < gridColumns.length; ++i) {
				var th = $(gridColumns[i]);
				var fieldName = th.data("field");
				var column = that._findColumn(fieldName);
				if (column && column.hidden) {
					continue;
				}

				if (th.hasClass("k-filterable") && column && !column.hidden) {	
					toolbarHtml += 
						"<th class=\"k-header konto-toolbar-filter\" data-field=\"" + fieldName + "\">" +
							"<div class=\"grid-filter-header\"><input class=\"k-textbox\" /></div></th>";
				}
				else if (th.data("field") == "CHECKED") {
					toolbarHtml += "<th class=\"k-header\"><input type=\"checkbox\" class=\"konto-check-all\" style=\"margin-left: 0.35em;\" /></th>";
				}
				else {
					toolbarHtml += "<th></th>";
				}
			}
			
			/**
			 * 
			 */
			var ariaStopPropagation = function (e) {
                if ($(this).closest("#aria_active_cell").length > 0) { 
                    e.stopPropagation();
                }
            };

			var suppressNextToolbarFilterBlur = false;
			var focusGridAfterToolbarFilter = function () {
				setTimeout(function () {
					grid.thead.find(".konto-filter-row").children().removeAttr("id");

					var firstCell = grid.tbody.find("td:visible").first();
					if (firstCell.length > 0 && grid.current) {
						try {
							grid.current(firstCell);
						} catch (e) { }
					}

					if (grid.table && grid.table.length > 0) {
						grid.table.attr("tabindex", 0);
						grid.table.focus();
					} else {
						grid.element.attr("tabindex", 0);
						grid.element.focus();
					}
				}, 0);
			};

			var toolbarFiltersEqual = function (oldFilters, newFilters) {
				var oldFilterItems = oldFilters && oldFilters.filters ? oldFilters.filters : [];
				if (oldFilterItems.length != newFilters.length) {
					return false;
				}

				for (var i = 0; i < newFilters.length; i++) {
					var newFilter = newFilters[i];
					var found = false;

					for (var j = 0; j < oldFilterItems.length; j++) {
						var oldFilter = oldFilterItems[j];
						if (oldFilter.field == newFilter.field &&
								oldFilter.operator == newFilter.operator &&
								oldFilter.value == newFilter.value) {
							found = true;
							break;
						}
					}

					if (!found) {
						return false;
					}
				}

				return true;
			};

			var applyToolbarFilters = function (focusInput) {
				var oldFilters = grid.dataSource.filter();
				var oldFil = null;
				var filters = [];
				var fieldName = "";
				$(grid.thead).find(".konto-toolbar-filter").each(function () {
					fieldName = $(this).data("field");
					var operator = null;
					oldFil = null;
					var column = that._findColumn(fieldName);
					if (column && column.filterable) {
						if (column.filterable.cell) {
							operator = column.filterable.cell.operator;
						}
					}
					if (!operator)
						operator = "contains";
					
					var inputElem = $(this).find("input");
					var value = $(inputElem).val();
					if (value == "")
						return;
					
					if (oldFilters && oldFilters.filters) {
						$.each(oldFilters.filters, function (key, value) {
			        		if (value.field == fieldName) {
								oldFil = value;
								return;
							}
			        	});
		        	}

					if (oldFil != null) {
						var filter = $.extend({}, oldFil);
						filter.value = value;
					} else {
						var filter = {
							operator: operator,
							value: value,
							field: fieldName
						};
					}
					
					filters.push(filter);
				});

				if (!toolbarFiltersEqual(oldFilters, filters)) {
					grid.dataSource.filter(filters);
				}

				if (focusInput && focusInput.length > 0) {
					setTimeout(function () {
						focusInput.focus();
					}, 0);
				} else {
					focusGridAfterToolbarFilter();
				}
			};
    
			var $filterRow = $("<tr class=\"konto-filter-row k-header\" role=\"row\">" + toolbarHtml + "</tr>");$
			
			var filterRowKendo = grid.thead.find('tr.k-filter-row');
			filterRowKendo.html(toolbarHtml).addClass('konto-filter-row');
			
			//$filterRow.appendTo(grid.thead);
		
			//$filterRow.appendTo(grid.thead)
			filterRowKendo
			    .keydown(function (e) {		    	
			        // Da ne ide iz jedne kućice u drugu.
			        if (e.which === 37 || e.which === 39) {
			        	e.stopPropagation(); 
			        }
			    })
			    .click(function (e) {
					//$(this).find("input").focus();
			    })
				.find(".konto-toolbar-filter input")
					.keyup(function(event) {

						if (event.which == 9) {
							var el = $(this);
							var parentRow = el.closest(".konto-filter-row");
							parentRow.children().removeAttr("id");
						}

						if (event.which == 13) {
							var oldFilters = grid.dataSource.filter();
							var oldFil = null;
							// Potraži sve moguće filtere.
							var filters = [];
							var fieldName = "";							
							$(grid.thead).find(".konto-toolbar-filter").each(function () {
								fieldName = $(this).data("field");
								var operator = null;
								oldFil = null;
								var column = that._findColumn(fieldName);
								if (column && column.filterable) {
									if (column.filterable.cell) {
										operator = column.filterable.cell.operator;
									}
								}
								if (!operator)
									operator = "contains";
								
								var inputElem = $(this).find("input");
								var value = $(inputElem).val();
								if (value == "")
									return;
								
								//ako postoje stari
								if (oldFilters && oldFilters.filters){
									//ovdje proći stare filtere i vidjeti ima li filter za polje, ako ima onda ga izvaditi i promjeniti vrijednost
									$.each(oldFilters.filters, function (key, value) {
						        		if (value.field == fieldName){
											oldFil = value;
											return;	
										}		
						        	});
					        	}

								
								if (oldFil != null){
									var filter = oldFil;	
									filter.value = value;
								}else{
									var filter = {
										operator: operator,
										value: value,
										field: fieldName
									};
								}
								
								filters.push(filter);
							});
		
							suppressNextToolbarFilterBlur = true;
							grid.dataSource.filter(filters);
							focusGridAfterToolbarFilter();
							setTimeout(function () {
								suppressNextToolbarFilterBlur = false;
							}, 100);
						}
						
					})
					.blur(function () {
						var input = $(this);
						setTimeout(function () {
							if (suppressNextToolbarFilterBlur) {
								suppressNextToolbarFilterBlur = false;
								focusGridAfterToolbarFilter();
								return;
							}

							if (document.activeElement !== input[0]) {
								var focusInput = null;
								var activeElement = $(document.activeElement);

								if (activeElement.is(".konto-toolbar-filter input") && activeElement.closest(grid.thead).length > 0) {
									focusInput = activeElement;
								}

								applyToolbarFilters(focusInput);
							}
						}, 0);
					})
					.on("mousedown", ariaStopPropagation);
			///kraj filter row
			grid.thead.find(".konto-check-all").click(function (e) {
				// Dodaj funkciju
				var checked = this.checked;
				grid.tbody.find("tr .row-checkbox").prop("checked", checked);
			});
			
	    },
	    _removeToolbarFilterPanel: function () {
			var filterRowKendo = this.grid.thead.find('tr.k-filter-row');
			filterRowKendo.remove();
		},
	    _clearFilterToolbar: function () {
	    	$(".konto-toolbar-filter input", this.grid.element).each(function (index, el) {
	    		$(el).val("");
	    	});
	    },
	    _postaviFilterToolbar: function (filter) {
	    	var grid = this.grid;	
	    	if (filter.filters) {
	    		for (var i = 0; i < filter.filters.length; ++i) {
	    			var f = filter.filters[i];
	    			this._postaviFilterToolbar(f);	    		
	    		}
	    	}
	    	else {
	    		var value = filter.value;
	    		var column = this._findColumn(filter.field);
	    		// U slučaju da nam kendov napredni filter šalje datum, onda je on tipa Date.
	    		// U slučaju kad smo mi napisali, on je string pa ga ne treba formatirati.
	    		if (column && (value instanceof Date)) {
	    			if (column.type == "datetime") {
	    				value = KUtils.formatDateTime(value, true);
	    			}
	    			else if (column.type == "time") {
	    				value = KUtils.formatTime(value);
	    			}
	    			else {
	    				value = KUtils.formatDate(value);
	    			}
	    		}
	    		
	    		var txt = $(".konto-toolbar-filter[data-field=" + filter.field + "]", grid.element).
	    			find(".k-textbox").val(value);
	    	}
	    },
	    _createToolbar: function () {
	    	if (this.options.noToolbar)
	    		return;
	    		
	    	var toolbar = this.grid.toolbar;
	    	var parent = this.element.find(".k-grid-toolbar");
    		//parent.css("position", "relative");
    		if (parent.data("hasToolbar"))
    			return;
    		
    		var kontoParent = parent;
    		kontoParent.addClass('konto-toolbar'); 		
    		// Right container
    		var rightContainer = this._getToolbarContainer(true);            
            rightContainer.append(this._kreirajSettingsDropdown());            
            
	    	kontoParent.append(rightContainer);
    		
	    	if (toolbar) {	
	    		// Left container 
	    		var leftContainer = this._getToolbarContainer();
	    		leftContainer.addClass("hidden-sm hidden-xs");
	    		leftContainer.append(this._getNormalToolbarItems(toolbar));
	    		kontoParent.append(leftContainer);
	    		
	    		var leftContainerSmall = this._getToolbarContainer();
	    		leftContainerSmall.addClass("hidden-lg hidden-md");
	    		//var items = this._getSmallToolbarItems(toolbar);
	    		//leftContainerSmall.append(items);
	    		//kontoParent.append(leftContainerSmall);
	    	}	 
	    	kontoParent.append($("<div>", { class: "clearfix" }));
	    	
	    	parent.append(kontoParent);
	    	
	    	parent.data("hasToolbar", true);
	    },
	    _postaviTitle: function () {
	    	this.grid.thead.find("tr").first().find("th").each(function (ind, el) {
	    		$(el).attr("title", $(el).data("title"));
	    	});
	    },
	    _postaviDivAfterToolbar: function(){
			if (this.options.noToolbar)
	    		return;	
	    	var div = this.options.divAfterToolbar;
	    	if (div){
	    		div.addClass('k-grid-divAfterToolbar');
	    		this.element.find(".k-grid-toolbar").after(div);
	    	}
	    },
	    _postaviDivAfterContent: function(){
	    	var div = this.options.divAfterContent;
	    	if (div){
	    		div.addClass('k-grid-divAfterContent');
	    		this.element.find(".k-grid-container").after(div);
	    	}
	    },
	    _getToolbarContainer: function (right) {
	    	var el = $("<div>");
	    	el.addClass("konto-grid-toolbar");
	    	el.addClass(right === true ? "right" : "left");
	    	return el;
	    },
	    _isRedakSelektiran: function () {
	    	var data = this.grid.select();
			if (!data || data.length === 0) {
				konto.dialogs.upozori({content : "Prvo označite redak s podacima."});
				return false;
			}
			return true;
	    },
	    _isSamoJedanRedakSelektiran: function () {
	    	var data = this.grid.select();
			if (!data || data.length === 0) {
				konto.dialogs.upozori({width:"25%", content: "Tablica je prazna."});
				return false;
			}	    	
			else{
				var selectedRows = 0;			
	        	if (this.options.checkboxSelection){
					var allRows = this.grid.tbody.find(".row-checkbox");					
					for(i=0; i<allRows.length; i++){
						if(allRows[i].checked)
							selectedRows++;
					}
	        	}       					
				if(selectedRows > 1) {
					konto.dialogs.upozori({width:"25%", content: "Odabranu radnju nije moguće izvršiti na više redaka."});
					return false;
				}
				else{
					if(selectedRows == 1){	
						var twoRowsSelected = false;				
						for(i=0; i<allRows.length; i++){
							var el = $(allRows[i]).closest("tr");
							if(el.hasClass("k-selected")){
								if(!allRows[i].checked){
									twoRowsSelected = true;	
									break;
								}						
							}
						}														
						if(twoRowsSelected){
							konto.dialogs.upozori({width:"25%", content: "Odabranu radnju nije moguće izvršiti na više redaka."});
							return false;							
						}
						else{
							return true;
						}
					}
					else{
						return true;
					}	
				} 
			}			
	    },	       
	    _getToolbarItemClick: function (btn) {
	    	var that = this;
	    	var oldClick = btn.click;

	    	return function () {
	    		var canClick = true;
				if (btn.requiresSelectedRow) {
					canClick = that._isRedakSelektiran();
				}
				if (btn.requiresOnlyOneSelectedRow) {
					canClick = that._isSamoJedanRedakSelektiran();					
				}				
				if (!canClick)
					return;
				if (oldClick) {
					// U kontekstu toolbar itema na koji je kliknuto.
					oldClick.call(this);
				}
	    	};
	    },
	    /**
	     * Vraća dropdown koji se koristi na mobilnim uređajima.
	     * */
	    _getSmallToolbarItems: function (toolbar) {
	    	var $group = $("<div>", { class: "btn-group" });
	    	var $button = this._kreirajButton({
	    		name: "Akcije "
	    	});
	    	$button.addClass("dropdown-toggle");
	    	$button.append($("<span>", { class: "caret" }));
	    	$button.attr("data-toggle", "dropdown");
	    	
	    	var $divider = $("<li>", { class: "divider" });
	    	var $menu = $("<ul>", { class: "dropdown-menu", role: "menu" });
	    	for (var i = 0; i < toolbar.length; ++i) {
	    		if (i > 0)
	    			$menu.append($divider.clone());
	    		var item = toolbar[i];
	    		if (typeof (item) === "object") {
	    			if (item.click)
	    				item.click = this._getToolbarItemClick(item);
	    			
	    			switch (item.type) {
	    				case "checkbox":
	    					$li = this._kreirajCheckboxDropdown(item);
							$menu.append($li);
	    					break;
	    				case "novi-dropdown":
	    				case "btn-dropdown":
	    				case "brisanje-dropdown":
	    				case "dropdown":
							var $submenuItem = $("<li>", { class: "dropdown-submenu" });
							var $submenuLink = $("<a>", { class: "dropdown-link", href: "#", text: item.name});
							var $caret = $("<span>", { class: "caret" });
							var $submenu = $("<ul>", { class: "dropdown-menu" });							
	    					var items = [];
	    					for (var j = 0; j < item.items.length; ++j) {
	    						var $li = this._kreirajDropdownItem(item.items[j]);
	    						items.push($li);
							}
							$submenuLink.append($caret);
							$submenuLink.on("click", function(e){
								$(this).next('ul').toggle();
								e.stopPropagation();
								e.preventDefault();
							})							
							$submenu.append(items);
							$submenuItem.append($submenuLink);
							$submenuItem.append($submenu);
							$menu.append($submenuItem);
	    					break;
	    				default:
	    					var $li = this._kreirajListItem(item);
	    					$menu.append($li);
	    			}
	    		}
	    	}
	    	$group.append($button);
	    	$group.append($menu);
	    	
	    	$ti = $("<div>", { class: "toolbar-item" });
	    	$ti.append($group);
	    	return $ti;
	    },
	    /**
	     * Vraća toolbar buttone.
	     * */
	    _getNormalToolbarItems: function (toolbar) {
	    	var items = [];
	    	for (var i = 0; i < toolbar.length; ++i) {
    			var toolbarItem = this._getToolbarItem(toolbar[i]);
    			items.push(toolbarItem);
    		}
	    	return items;
	    },
	    _getToolbarItem: function (t) {
	    	var wrapper = $("<div>");
	    	wrapper.addClass("toolbar-item");
	    	if (t.hide){
	    	  wrapper.addClass("hide");    
	    	}
	    	if (typeof (t) === "string") {
	    		wrapper.append(t);
	    	}
	    	else if (typeof (t) === "object") {
	    		if (t.click)
	    			t.click = this._getToolbarItemClick(t);
	    		
	    		switch (t.type) {
		    		case "checkbox":
		    			var cb = this._kreirajCheckbox(t);
		    			wrapper.append(cb);
		    			break;
		    		case "btn-checkbox":
		    			var cb = this._kreirajBtnCheckbox(t);
		    			wrapper.append(cb);
		    			break;		    			
		    		case "novi-dropdown":
		    			var btn = this._kreirajDropdownButton(t);
		    			wrapper.append(btn);
		    			break;
		    		case "btn-dropdown":
		    			var btn = this._kreirajBtnDropdownButton(t);
		    			wrapper.append(btn);
		    			break;
		    		case "btn-dropdown-simple":
		    			var btn = this._kreirajBtnDropdownButtonSimple(t);
		    			wrapper.append(btn);
		    			break;		    			
		    		case "brisanje-dropdown":
		    			var btn = this._kreirajDropdownButton(t);
		    			wrapper.append(btn);
		    			break;
		    		case "dropdown":
		    			var btn = this._kreirajDropdownButton(t);
		    			wrapper.append(btn);
		    			break;
		    		case "label":
		    			var label = this._kreirajLabel(t);
		    			wrapper.append(label);
		    			break;
		    		case "input":
		    			var input = this._kreirajInput(t);
		    			wrapper.append(input);
		    			break;                                                                        
		    		default:
		    			var btn = this._kreirajButton(t);
		    			wrapper.append(btn);
		    			
	    		}
	    	}
	    	return wrapper;
		},
		_setBtnBsKlasa: function(button){
			var cl = "";
			if (typeof button.classes != 'undefined')
				cl = button.classes;
			if (typeof button.additionalClass != 'undefined')
				cl = button.additionalClass;

			if (cl.indexOf("btn-") !== -1)
				return ""
			else
				return "btn-light"; 
		},
	    _kreirajButton: function (button, nazivForce) {
	    	var btnIkona="",
				btnBoja;
			var naziv = button.name;
			if((nazivForce !== undefined) && (nazivForce !== '')){
				naziv = nazivForce;
			}
			if (!naziv) {
				switch (button.type) {
				case "novi":
					naziv = "Novi";
					break;
				case "ispravak":
					naziv = "Ispravak";
					break;
				case "brisanje":
					naziv = "Brisanje";
					break;					
				}
			}
			 
			switch (button.type) {
			    case "novi":
			        btnIkona = "<i class='fas fa-file-alt'></i> ";
			        btnBoja = "btn-primary";
			        break;
			    case "brisanje":
			        btnIkona = "<i class='far fa-trash-alt'></i> ";
			        btnBoja = this._setBtnBsKlasa(button);
			        break;			        
			    case "ispravak":
			    	btnIkona = "<i class='far fa-edit'></i> ";
			    	btnBoja = "btn-light";
			        break;
			    case "filter":
			    	btnIkona = "<i class='fas fa-sliders-h'></i> ";
			    	btnBoja = "btn-light";
			        break;   					
			    case "ispis":
					btnIkona = "<i class='fas fa-print'></i> ";
					btnBoja = "btn-light";	
				default:
					btnBoja = this._setBtnBsKlasa(button);
			}
			
			if (button.boja)
				btnBoja = buttonBoja;
			if (button.ikona)
				btnIkona = "<i class='" + button.ikona + "'></i> ";
			
			var btn = $("<button>");
			btn.attr("type", "button");
			btn.addClass("btn").addClass(btnBoja);
			
			if (typeof button.id != 'undefined')
				btn.attr('id', button.id);
				
			if (typeof button.additionalClass != 'undefined')
				btn.addClass(button.additionalClass);				
				
			if (typeof button.disabled != 'undefined' && button.disabled == true)
				btn.attr('disabled', 'disabled');

            // dodajem radi jednostavnosti
			if (typeof button.classes != 'undefined')
			    btn.addClass(button.classes);
			
			if (button.title)
				btn.attr("title", button.title);

			btn.append(btnIkona);
			btn.append(naziv);
			if (button.click)
				btn.click(button.click);
			
			return btn;
	    },
	    _kreirajListItem: function (item) {
	    	var $li = $("<li>");
	    	
	    	var idI = '';
	    	if (item.id){
	    		idI = 'Akcije' + item.id;
	    		var $a = $("<a>", { click: item.click, id: idI, text: item.name });	
	    	}else{
	    		var $a = $("<a>", { click: item.click, text: item.name });
	    	}

			$li.append($a);
			return $li;
	    },
	    _kreirajDropdownButton: function (button) {
	    	var div = $("<div>");
	    	div.addClass("dropdown");
	    	if (button.classes) {
	    		div.addClass(button.classes);
	    	}
	    	
	    	var btn = $("<button>");
	    	btn.attr("type", "button");
	    	btn.attr("data-toggle", "dropdown");
			btn.addClass("btn").addClass("dropdown-toggle");
			btn.attr("aria-haspopup", "true");
			btn.attr("aria-expanded", "false");
	    	
	    	if (typeof button.id != 'undefined')
				btn.attr('id', button.id);
		
			if (button.title)
				btn.attr("title", button.title);
				
            if (typeof button.disabled != 'undefined' && button.disabled == true)
                btn.attr('disabled', 'disabled');				

	    	if (button.type == "novi-dropdown")
	    		btn.addClass("btn-primary");
	    	else if (button.type == "brisanje-dropdown")
	    		btn.addClass("btn-danger");
	    	else 
	    		btn.addClass("btn-light");
	    	div.append(btn);
	    	
	    	var menu = $("<div>");
	    	menu.addClass("dropdown-menu");
	    	div.append(menu);
	    	
	    	if (typeof button.ikona !== 'undefined')
	    		var ikona = ''+ button.ikona;
	    	else
	    		var ikona = 'far fa-file-alt';
	    	
	    	btn.append("<i class='"+ikona+"'></i> " + button.name + " <span class=\"caret\"></span>");
	    	for (var i = 0; i < button.items.length; ++i) {
	    	    var item = button.items[i];
	    	    if (item.click) {
	    	        this._getToolbarItemClick(item);
	    	    }
	    		var dropItem = this._kreirajDropdownItem(item);
	    		menu.append(dropItem);
	    	}
	    	return div;
	    },
		_kreirajBtnDropdownButton: function (button) {
	    	var div = $("<div>");
			div.addClass("btn-group");
	    	if (button.classes) {
	    		div.addClass(button.classes);
	    	}

	    	var prva = button.items[0];	
    		if (prva.click) {
    	        prva.click = this._getToolbarItemClick(prva);
    	    } 	
    	    var nazivDropDowna = '';
    	    if(button.name !== undefined){
    	    	nazivDropDowna = button.name;	
    	    }
	    	var btn = this._kreirajButton(prva, nazivDropDowna);
			switch (prva.type) {
			    case "novi":
			        btnBoja = "btn-primary";
			        break; 	
				case "brisanje":
					btnBoja = "btn-danger";
					break;						
				default:
					btnBoja = "btn-light";   	
			}
			
			if (button.boja)
				btnBoja = buttonBoja;

	    	var btnDrop = $("<button>");
	    	btnDrop.attr("type", "button");
	    	btnDrop.attr("data-toggle", "dropdown");
	    	btnDrop.addClass("btn").addClass("dropdown-toggle");   	
	    	
	    	btnDrop.addClass(btnBoja);
	    	div.append(btn);	    	
	    	div.append(btnDrop);
	    	
	    	var menu = $("<ul>");
	    	menu.addClass("dropdown-menu");
	    	menu.attr("role", "menu");
	    	div.append(menu);
	    	
	    	if(div.hasClass("hasClickEvent")){
	            if (typeof button.click === "function") {
	            	if(button.click.call !== undefined){
		                btnDrop.click(function (event) {
		                    button.click.call();
		                });
	            	}
	            }	    		
	    	}
	    	
	    	btnDrop.append("<span class=\"caret\"></span>");
	    	for (var i = 0; i < button.items.length; ++i) {
	    	    var item = button.items[i];
	    	    if (item.click) {
	    	        this._getToolbarItemClick(item);
	    	    }
	    		var dropItem = this._kreirajDropdownItem(item);
	    		menu.append(dropItem);
	    	}
	    	return div;
	    },
		_kreirajBtnDropdownButtonSimple: function (button) {
	    	var div = $("<div>");
			div.addClass("btn-group");
	    	if (button.classes) {
	    		div.addClass(button.classes);
	    	}

    	    var nazivDropDowna = '';
    	    if(button.name !== undefined){
    	    	nazivDropDowna = button.name;	
    	    }
	    	var btn = this._kreirajButton(button, nazivDropDowna);
			
	    	var prva = button.items[0];	
			switch (prva.type) {
			    case "novi":
			        btnBoja = "btn-primary";
			        break; 	
				default:
					btnBoja = "btn-light";   	
			}	
			if (button.boja)
				btnBoja = buttonBoja;

	    	var btnDrop = $("<button>");
	    	btnDrop.attr("type", "button");
	    	btnDrop.attr("data-toggle", "dropdown");
	    	btnDrop.addClass("btn").addClass("dropdown-toggle");   		    	    		    		    
	    		    	
	    	btn.removeClass("hasClickEvent");
	    	btn.off();
	    		    		    	
	    	btnDrop.addClass(btnBoja);
	    	div.append(btn);	    	
	    	div.append(btnDrop);
	    	
	    	var menu = $("<ul>");
	    	menu.addClass("dropdown-menu");
	    	menu.attr("role", "menu");
	    	div.append(menu);
	    	
	    	if(div.hasClass("hasClickEvent")){
	            if (typeof button.click === "function") {
	            	if(button.click.call !== undefined){
		                btnDrop.click(function () {
		                    button.click.call();
		                });	
		                btn.click(function (event) {
		                    KUtils.StopAllEvents(event);
		                    btnDrop.click();
		                });		                	                
	            	}
	            }	    		
	    	}	    	    	
	    	
	    	btnDrop.append("<span class=\"caret\"></span>");
	    	for (var i = 0; i < button.items.length; ++i) {
	    	    var item = button.items[i];
	    	    if (item.click) {
	    	        this._getToolbarItemClick(item);
	    	    }
	    		var dropItem = this._kreirajDropdownItem(item);
	    		menu.append(dropItem);
	    	}
	    	  	
	    	return div;
	    },	    
	    /**
	     * Kreira divider ili li element.
	     * Trebalo bi napraviti da kreira element ovisno o tipu - checkbox se 
	     * ponaša drugačije.
	     */
	    _kreirajDropdownItem: function (item) {
	    	// ovo je izgleda krivo, ali ako se negdje ne koristi ne mijenjam
            if (item == "divider") {
	    		return $("<div class=\"dropdown-divider\"></div>");
	    	}
	    	else if (item.type == "divider") {
	    		return $("<div class=\"dropdown-divider\"></div>");
	    	}            
	    	else if (item.type == "checkbox") {
	    	    return this._kreirajCheckboxDropdown(item);
	    	}
	    	else if (item.type == "btn-checkbox") {
	    	    return this._kreirajBtnCheckboxDropdown(item);
	    	}	    	
	    	else if (item.type == "group-divider") {
	    		return $('<li class="group-divider">'+item.name+'</li>');
	    	}
	    	else {
				var ikona = '';				
	    		if (typeof item.ikona !== 'undefined')
	    			ikona = "<i class='" + item.ikona +"'></i> ";
				
				var title = '';
				if (item.title){
					title = "title=" + "'" + item.title + "'";
				}
				
	    		var $a = $("<a class='dropdown-item' " + title + " >" + ikona + item.name + "</a>");
			
				if (item.classes) {
					$a.addClass(item.classes);
				}
				
				if (item.id) {
					$a.attr('id', item.id);			
				}
				
                if (typeof item.disabled != 'undefined' && item.disabled == true)
                    $a.addClass('disabled');
				
				//edit by Davor - da bi se vrsila provjera "requiresSelectedRow" u itemima dropdown-a
				$a.click(this._getToolbarItemClick(item)); 		
				//$li.click(item.click); //staro
				
				return $a;
	    	}
	    },
	    _kreirajCheckbox: function (item) {
			var div = $("<div>");
			div.addClass("btn-group-toggle");
			div.attr("data-toggle", "buttons");
			if(item.id)
                div.attr("id", item.id);			
			if(item.title)
                div.attr("title", item.title);			
			var cb = $("<input>");
			cb.attr("type", "checkbox");
			
			//izmjena
			if (typeof item.additionalClass != 'undefined')
				cb.addClass("class", item.additionalClass);
			
			cb.attr("checked", item.checked === true ? "checked" : null);
			var label = $("<label>");
			if (item.idLab){
				label.attr('id', item.idLab);	
			}
			label.addClass("btn").addClass("btn-light");
			
			if (item.checked)
				label.addClass("active").addClass("active-green");
			else
				label.removeClass("active").removeClass("active-green");
				
            var ikona = '';             
            if (typeof item.ikona !== 'undefined')
                ikona = "<i class='" + item.ikona +"'></i> ";

			label.html(ikona + item.name);
			label.append(cb);
			
			div.append(label);
			if (item.orientation === "right")
				div.css("float", "right");
			
			div.button();
			if (item.click) {
                div.on("state-changed", function () {
					var cb = $(this).find("input")[0];					
                    item.click.call(cb);					
					var label = $(cb).closest("label");
					$(label).removeClass("focus");
					if (cb.checked){
						$(label).addClass('active-green');
					}else{
						$(label).removeClass('active-green');
					}
                });
			}
			
			return div;
	    },
	    _kreirajBtnCheckbox: function (item) {
			var div = $("<div>");
			div.addClass("btn-group-toggle");
			div.attr("data-toggle", "buttons");
			if(item.id)
                div.attr("id", item.id);			
			if(item.title)
                div.attr("title", item.title);			
			var cb = $("<input>");
			cb.attr("type", "checkbox");
			
			//izmjena
			if (typeof item.additionalClass != 'undefined')
				cb.addClass("class", item.additionalClass);
			
			cb.attr("checked", item.checked === true ? "checked" : null);
			var label = $("<label>");
			if (item.idLab){
				label.attr('id', item.idLab);	
			}
			label.addClass("btn").addClass("btn-light");
			
			if (item.checked)
				label.addClass("active");
			else
				label.removeClass("active");
				
            var ikona = '';             
            if (typeof item.ikona !== 'undefined')
                ikona = "<i class='" + item.ikona +"'></i> ";

			label.html(ikona + item.name);
			label.append(cb);
			
			div.append(label);
			if (item.orientation === "right")
				div.css("float", "right");
			
			div.button();
			if (item.click) {
                div.on("state-changed", function () {
					var cb = $(this).find("input")[0];
					$(cb).closest(label).removeClass("focus")
                    item.click.call(cb);
                });
			}
			
			return div;
	    },	    
	    _kreirajCheckboxDropdown: function (item) {
	        var $cb = $("<input>", { type: "checkbox", checked: (item.checked === true ? "checked" : null) });
            $cb.css("display", "none");

			if (typeof item.id != 'undefined') {
				$cb.attr('id', item.id);				
			}
			if (typeof item.classes != 'undefined') {
			    $cb.addClass(item.classes);				
			}
			    				
			//izmjena
			if (typeof item.additionalClass != 'undefined') {
				$cb.addClass(item.additionalClass);
			}
        
            var $cbIcon = $("<i>", { class: "check-icon fa" });
            if (item.checked === true)
                $cbIcon.addClass("fa-check").addClass("pr-2");

           
			var $a = $("<a>");
			$a.addClass("dropdown-link text-dark");
			if (typeof item.disabled != 'undefined' && item.disabled == true){
				$a.addClass('k-disabled');
			}
            
            var $label = $("<label>", { text: item.name });
            $label.css("font-weight", "normal");
            
            $a.append($cbIcon);
            $a.append($label);
            
			var $li = $("<li>");
			$li.addClass("dropdown-item");
            if (typeof item.click === "function") {
                $li.click(function (event) {
					//za disabled
					if ($a.hasClass('k-disabled'))
						return;
						
                    var cb = $(this).find("input")[0];
                    cb.checked = cb.checked ? false : true;
                    $(this).find(".check-icon").toggleClass("fa-check pr-2", cb.checked);
                    item.click.call(cb);
                });
            }
                
            $li.append($cb);
            $li.append($a);  
            return $li;
	    },
	    _kreirajBtnCheckboxDropdown: function (item) {          
			var $a = $("<a>");
			$a.addClass("dropdown-item");
			
	        var $cb = $("<input>", { type: "checkbox", checked: (item.checked === true ? "checked" : null) });
            $cb.css("display", "none");

			if (typeof item.id != 'undefined') {
				$cb.attr('id', item.id);				
			}
			if (typeof item.classes != 'undefined') {
			    $cb.addClass(item.classes);				
			}
			    				
			//izmjena
			if (typeof item.additionalClass != 'undefined') {
				$cb.addClass(item.additionalClass);
			}			
			
            var $cbIcon = $("<i>", { class: "check-icon fa" });
            if (item.checked === true)
                $cbIcon.addClass("fa-check");	
                          
            var $label = $("<span>", { text: item.name });
            $label.css("font-weight", "normal");
           
            if (typeof item.click === "function") {
                $a.click(function (event) {
                    var cb = $(this).find("input")[0];
                    var label = $(this).find("span");
                    var tekst = label.text();
                    var result = item.click.call(cb);
                    if(result){
                        cb.checked = true;
	                    $(this).find(".check-icon").addClass("fa-check");
	                    label.text(' ' + tekst);
                    }
                    else{
                        cb.checked = false;
	                    $(this).find(".check-icon").removeClass("fa-check");  
	                    label.text(tekst.trim());                  	
                    }
                });
            }           
           
            $a.append($cb);           
            $a.append($cbIcon);
            $a.append($label);
                       
           return $a;
	    },	    
	    _getParametriIspisaDiv: function () {
	    	var div = $("<div>", { class: "row" });
	    	var checkboxes = $("<div>", { class: "col-md-4 checkboxes" });
	    	checkboxes.append(this._getColumnsCheckboxes());
	    	
	    	var ostalo = $("<div>", { class: "col-md-8 ostalo" });
	    	
	    	var fgVrijeme = $("<div>", { class: "form-group" })
	    		.append($("<label>", { text: "Vrijeme ispisa" }))
	    		.append($("<input>", { type: "text", class: "vrijeme-ispisa" }));
	    	fgVrijeme.find(".vrijeme-ispisa").kendoDateTimePicker({
	    		value: new Date()
	    	});
	    	
	    	var fgTitle = $("<div>", { class: "form-group"})
	    		.append($("<label>", { text: "Naslov izvještaja" } ))
	    		.append($("<input>", { type: "text", class: "form-control export-title", value: this.options.export.title }));
	    	
	    	ostalo.append(fgVrijeme);
	    	ostalo.append(fgTitle);
	    	
	    	div.append(checkboxes);
	    	div.append(ostalo);
	    	
	    	return div;
	    },
	    _getColumnsCheckboxes: function () {
	    	var that = this;
	    	var columns = that.grid.columns;
	    	if (!columns || columns.length == 0)
	    		return null;
	    	var w = $("<div>");
	    	for (var i = 0; i < columns.length; ++i) {
	    		if (!columns[i].hidden){
		    		var cb = $("<div>", { class: "checkbox" });
		    		var label = $("<label>", { title: columns[i].title + " (" + columns[i].field + ")" });
		    		var isExcluded = $.inArray(columns[i].field.toUpperCase(), that.options.export.excludedColumns) > -1;
		    		var input = $("<input>", { type: "checkbox", checked: (isExcluded ? false : "checked") });
		    		input.data("value", columns[i]);
		    		label.append(input).append(" " + columns[i].title);
		    		
		    		cb.append(label);
		    		w.append(cb);
		    	}
	    	}
	    	return w;
	    },
	    /**
	     * Funkcija koja se izvršava prilikom klika na "Snimi" button na dialogu exporta.
	     * */
	    _getExportSnimiClick: function(paramsDiv, exportType) {
	    	var that = this;
	    	return function () {
				var columns = [];
				var checked = paramsDiv.find(".checkboxes input[type=checkbox]:checked");
				for (var i = 0; i < checked.length; ++i) {
					columns.push($(checked[i]).data("value").field);
				}
				
				var dtp = paramsDiv.find("input.vrijeme-ispisa").data("kendoDateTimePicker");
				var vrijemeIspisa = dtp.value();
				if (!vrijemeIspisa)
					vrijemeIspisa = new Date();
				
				that.setAjaxOption("ExportData", { 
					type: exportType, 
					title: paramsDiv.find(".export-title").val(), 
					vrijemeIspisa: vrijemeIspisa.toISOString(),
					columns: columns
				});
				
				/**
	     		 * Funkcija kojom se određuje treba li popuniti grid s podacima.
	     		 * 
	     		 * Dokumentacija:
	     		 * If invoked prevents the data bind action. 
	     		 * The table rows will remain unchanged and dataBound event will not fire.
	     		 * 
	     		 * Event unbinda sam sebe zbog toga da bi mogao grid dalje ići po podatke.
	     		 * */
	     		var onDataBound = function (e) {
	     			that.removeAjaxOption("ExportData");
     				e.preventDefault();

	     			that.grid.unbind("dataBinding", onDataBound);
	     		};
	     		that.grid.bind("dataBinding", onDataBound);
	     
				var dlg = this;
				that.grid.dataSource.fetch(function () {
					// Prikaže se progress image nad cijelim gridom pa treba maknuti.
					kendo.ui.progress(that.element, false);
					var data = this.data();
					kontorouter.gotoLocation("uploadcache/file/" + data[0]);
				});
			};
	    },
	    _getExportPdfButton: function () {
	    	var that = this;
	    	var exportPdf = $("<button>");
			exportPdf.attr("type", "button");
			exportPdf.attr("title", "Export PDF");
			exportPdf.addClass("btn btn-light");
			exportPdf.append("<i class='far fa-file-pdf'></i>");
			exportPdf.click(function (event) {
				var paramsDiv = that._getParametriIspisaDiv();
				$.dialog({
					title: "Odaberite parametre za export",
					content: paramsDiv,
					buttons: {
						"Snimi": {
							isPrimary: true,
							click: that._getExportSnimiClick(paramsDiv, "pdf")
						},
						"Odustani": function () {
							this.close();
						}
					}
				});
			});
			return exportPdf;
	    },
	    _getExportXlsButton: function () {
	    	var that = this;
	    	var exportXls = $("<button>");
			exportXls.attr("type", "button");
			exportXls.attr("title", "Export Excel");
			exportXls.addClass("btn btn-light");
			exportXls.append("<i class='far fa-file-excel'></i>");
			exportXls.click(function (event) {
				var paramsDiv = that._getParametriIspisaDiv();
				$.dialog({
					title: "Odaberite parametre za export",
					content: paramsDiv,
					buttons: {
						"Snimi": {
							isPrimary: true,
							click: that._getExportSnimiClick(paramsDiv, "xls")
						},
						"Odustani": function () {
							this.close();
						}
					}
				});
			});
			return exportXls;
	    },
	    /**
	     * Funkcija koja fokusira ćeliju s filterom. 
	     * Defaultno ponašanje je da th dobiva fokus, a ne input unutar njega.
	     * */
	    _focusFilterInput: function () {
	    	var activeCell = this.grid.element.find("#aria_active_cell");
        	if (activeCell.hasClass("konto-toolbar-filter")) {
        		activeCell.find("input").focus();
        	}
	    },
	    _kreirajSettingsDropdown: function () {
	    	var that = this;
	    	// Kreiram tools menu.
			var dropdown = $("<div>");
			dropdown.css("margin-right", "10px");

            if (this.options.toolbarRight){
                dropdown.append(this._getNormalToolbarItems(this.options.toolbarRight));                
            }           	    	            

            var wrapper = null;
               
            if (that.options.toolbarFiltering) { 
			    wrapper = $("<div>");
    		    wrapper.addClass("toolbar-item");	
    			
    			var obrisiFiltere = $("<button>");
    			obrisiFiltere.attr("type", "button");
    			obrisiFiltere.attr("title", "Obriši filtere");
    			obrisiFiltere.addClass("btn btn-light btn-obrisi-filtere");
    			obrisiFiltere.append("<i class='fas fa-filter'></i>");
    			obrisiFiltere.click(function (event) {
    				that.grid.dataSource.filter([]);
					$(".konto-filter-row input", that.grid.thead).each(function(){
						$(this).val("");
					});
    			});
    			wrapper.append(obrisiFiltere);
    			dropdown.append(wrapper);			
            }

            if (that.options.sortable !== false) {
    			wrapper = $("<div>");
    			wrapper.addClass("toolbar-item");				
    			var obrisiSortiranja = $("<button>");
    			obrisiSortiranja.attr("type", "button");
    			obrisiSortiranja.attr("title", "Obriši sortiranja");
    			obrisiSortiranja.addClass("btn btn-light btn-obrisi-sortiranja");
    			obrisiSortiranja.append("<i class='fas fa-sort-alpha-down'></i>");
    			//obrisiSortiranja.append("Obriši sortiranja");
    			obrisiSortiranja.click(function (event) {
    				that.grid.dataSource.sort([]);
    			});
    			wrapper.append(obrisiSortiranja);
    			dropdown.append(wrapper);	
			}
						
            //gumb za prikaz pune visine retka
			if (that.options.fullRowHeightToolbar != false) {
    			wrapper = $("<div>");
    			wrapper.addClass("toolbar-item");				
    			var puniRedak = $("<button>");
    			puniRedak.attr("type", "button");
    			puniRedak.attr("title", "Prikaži puni redak");
    			puniRedak.addClass("btn btn-light btn-puni-redak");
    			puniRedak.append("<i class='fas fa-arrows-alt-v'></i>");
    			
    			if (that.grid.fullRow){
    				that.grid.table.addClass('showLargeCell');
    				puniRedak.addClass('active-green');	
    			}else{
			    	that.grid.table.removeClass('showLargeCell');
					puniRedak.removeClass('active-green');	
    			}
    			
    			puniRedak.click(function (event) {
    				that.grid.fullRow = !that.grid.fullRow;
    				var tablica = that.grid.table;
    				if (tablica.hasClass('showLargeCell')) {
    					tablica.removeClass('showLargeCell');
    					$(this).removeClass('active-green');
    				} else {
    					tablica.addClass('showLargeCell');
    					$(this).addClass('active-green');
					}
					
    			});
    			wrapper.append(puniRedak);
    			dropdown.append(wrapper);	
			}
			
			//if (that.grid.options.remember.columns || that.options.remember.columns) - ako ne želimo da svi imaju taj button
			if (that.options.reorderToolbar != false) {
    			wrapper = $("<div>");
    			wrapper.addClass("toolbar-item");				
    			var bReorder = $("<button>");
    			bReorder.attr("type", "button");
    			bReorder.attr("title", "Obriši raspored stupaca");
    			bReorder.addClass("btn btn-light btn-obrisi-reorder");
    			bReorder.append("<i class='fas fa-columns'></i>");
    			
    			bReorder.click(function (event) {
					//ako se klikne u modalu, ništa se ne dogodi, treba naći način da se dogodi
					var p = this.closest("[data-role=kontomodal]");
                    if (!p) {
						that.grid.options.remember.columns = false;
						that.options.remember.columns = false;
						that.options.reorderTitle = '';
						$(this).removeClass('active-green');	
						location.reload();
					}	
    			});
    			
    			wrapper.append(bReorder);
    			dropdown.append(wrapper);
			}

			
			// Ovo u dropdown?
			if (that.options.export.exportPDF) {
				wrapper = $("<div>");
				wrapper.addClass("toolbar-item");			
				wrapper.append(that._getExportPdfButton());
				dropdown.append(wrapper);
			}
			
			
			if (that.options.export.exportXLS) {
				wrapper = $("<div>");
				wrapper.addClass("toolbar-item");	
				wrapper.append(that._getExportXlsButton());
				dropdown.append(wrapper);
			}
			return dropdown;			
	    },
        _kreirajLabel: function(item){ 
            var label = $("<label>");
            if (item.classes)            
			    label.addClass(item.classes);
            if (item.style)            
			    label.css(item.style);                                          
            label.append(item.content);                   
            return label;           
        },
        _kreirajInput: function(item){ 
            var input = $("<input>");
            if (item.classes)            
			    input.addClass(item.classes);
            if (item.value)            
			    input.attr("value", item.value);                
            if (item.style)            
			    input.css(item.style);                                          
            input.append(item.content);                   
            return input;           
        },
        _kreirajDesniIzbornik: function(obj, locked){
            var menuId = obj.grid.substring(1, obj.grid.length) + "-ContextMenu";
            if (locked){
            	menuId += '-locked';
            	var target = obj.grid + " .k-grid-content-locked table";
           	}else{
           		var target = obj.grid + " .k-grid-content table";
           	}
            var menu = $("<ul>", {
                id: menuId
            });   
            for (var index = 0; index < obj.items.length; index++) {
                var el = obj.items[index];                            
                var item = $("<li>");
                
                if (el.text){
                    item.text(el.text);
                }
                if (el.click){
                    item.click(el.click);
                }                                                                                    
                item.appendTo(menu);                                                      
            }
            $("#ajax-content").append(menu); 
                      
            $("#" + menuId).kendoContextMenu({
                target: target
            });                                                                                                                                    
        },                
        getGridValues: function () {
            if (this.options.remember === false || 
                typeof (this.options.remember) === "undefined") 
                return null;
        	var grid = this.grid;
        	var row = grid.select();
        	var dataItem = grid.dataItem(row);
        	//if (dataItem == null)
        	//	return null;
        	var keyFields = this.options.keyFields;
        	if (keyFields.length == 0)
        		return null;
        	var columnValues = {};
        	if (dataItem) {
	        	for (var i = 0; i < keyFields.length; ++i) {
	        		var column = keyFields[i];
                        var val = dataItem[column];
                        if (typeof val == 'object'){
                            try{
                                val = KUtils.formatDate(val);     
                            } catch (e) {  } 
                        }
                        columnValues[column] = val;
	        	}
        	}
        	var values = {};
        	if (this.options.remember.currentRecord) {
                values.columns = columnValues;
        	}
        	values.grid = {};
        	if (this.options.remember.page) {
        	   values.grid.page = grid.dataSource.page();
        	   values.grid.pageSize = grid.dataSource.pageSize();
            }
            if (this.options.remember.sort) {
        	   values.grid.sort = grid.dataSource.sort();
        	}
        	if (this.options.remember.filter) {
            	var filters = grid.dataSource.filter();
            	if (typeof filters !== "undefined") {
            		values.grid.filters = filters;
            	}
        	}
            if (this.options.remember.fullRow) {
        	   values.grid.fullRow = grid.fullRow;
        	}
        	
        	if (grid.options.remember.columns || this.options.remember.columns) {
        	   values.grid.columns = grid.getOptions().columns;
        	   values.grid.reorderTitle = grid.getOptions().reorderTitle;
        	}
        	
        	return values;
        },
        refresh: function (sacuvajPoziciju) {          
            if (typeof sacuvajPoziciju !== "boolean")
                sacuvajPoziciju = true;
            this.options.noviObject = sacuvajPoziciju ? this.getSelectedData() : null;
            //ako se dogodi ajax refresh prije nego su učitani podaci u glavni grid, postoji zapis o tome gdje se treba vratiti u  selValues
            if (sacuvajPoziciju && (this.options.noviObject == null) && this.options.selValues && this.options.selValues.columns){
            	this.options.noviObject = this.options.selValues.columns;	
            }
        	this.grid.dataSource.read();
     	
        	if (this.options.checkboxSelection){
        		this.grid.thead.find(".konto-check-all").prop("checked", false);	
        	}
        },
        refreshAfterNew: function (sifarnikNoviObject, sacuvajPoziciju) { 
			if(sifarnikNoviObject){
				newInsertedObject = sifarnikNoviObject;
			}
			else{
				newInsertedObject = simpleStorage.get('NewInsertedObject');
			}
			if(newInsertedObject){
				var columnsFound = 0; 
				var columnsTotal = 0;
				var oldValues = this.options.selValues;
				var columns = oldValues.columns;
				for(var key in columns){
					columnsTotal++;
					for(var field in newInsertedObject){
						var upperField = field.toUpperCase().substring(1);
						if(key == upperField){
							var keyValue = newInsertedObject[field]; 
							columns[key] = keyValue; 
							columnsFound++;
						}
					}                 
				}      
				if((columnsFound == columnsTotal) && (columnsTotal != 0)){
					this.grid.dataSource.transport.options.read.data.selValues = columns;	
					this.options.noviObject = columns;
					this.grid.dataSource.read();	
					
					if (this.options.checkboxSelection){
						this.grid.thead.find(".konto-check-all").prop("checked", false);	
					}
					simpleStorage.deleteKey('NewInsertedObject');
				}
				else{
					this.refresh(sacuvajPoziciju);
				}     
			}
			else{
				this.refresh(sacuvajPoziciju);
			}
        },		
        refreshAfterDelete: function (sacuvajPoziciju) {
            try{
                if (typeof sacuvajPoziciju !== "boolean")
                    sacuvajPoziciju = true;
                this.options.noviObject = sacuvajPoziciju ? this.getSelectedDataAfterDelete() : null;
                if (this.options.noviObject == 'selectLastRow'){
                	this.options.noviObject = null;	
                	this.options.selectLastRow = true;
                }else{
                	this.options.selectLastRow = null;	
                }
                this.grid.dataSource.transport.options.read.data.selValues = null;
                
                if (this.options.selectLastRow && this.grid.dataSource.data().length == 1){
                    var page = this.grid.dataSource.page();
                    this.grid.dataSource.page( page - 1 );
                }else{
                    this.grid.dataSource.read();    
                }   
            	if (this.options.checkboxSelection){
            		this.grid.thead.find(".konto-check-all").prop("checked", false);	
            	}  
            } catch (e) {  }    
        },
        getSelectedData: function () {     	
        	var grid = this.grid;
        	var row = grid.select();
        	if (row.length > 0) {
        		var items = [];
        		for (var i = 0; i < row.length; ++i) {
        			items.push(grid.dataItem(row[i]));
        		}
        		if ((items.length == 1) || ((items.length == 2) && (items[0] == items[1]))) {
        			//zašto ovakav or? zbog locked celija ... grid.select() vrati 2 reda (za locked i obicne) ali grid.dataItem(x) od oba daje isti rezultat. 
        			return items[0];
        		}
        		return items;
        	}
        	else
        		return grid.dataItem(row);
        },  
        getSelectedDataAfterDelete: function () {
        	// nakon brisanja se pokazivač postavlja na slijedeću stavku, a ako se utvrdi da je to bila zadnja stavka onda na prethodnu
        	var grid = this.grid;
        	var rowSelected = grid.select();
        	var rows = grid.tbody.find("tr"); // Tražim rowse
        	
        	for (var i = 0; i < rows.length; ++i) {
        		var row = $(rows[i]);
        		if (row[0] == rowSelected[0] ){
        			i++;
        			if (i != rows.length){
        				row = $(rows[i]);
        			}else{
        				return 'selectLastRow';	
        			}
        			break;	
        		}
        	}	
        
        	
        	if (row.length > 0) {
        		var items = [];
        		for (var i = 0; i < row.length; ++i) {
        			items.push(grid.dataItem(row[i]));
        		}
        		if ((items.length == 1) || ((items.length == 2) && (items[0] == items[1]))) {
        			//zašto ovakav or? zbog locked celija ... grid.select() vrati 2 reda (za locked i obicne) ali grid.dataItem(x) od oba daje isti rezultat. 
        			return items[0];
        		}
        		return items;
        	}
        	else
        		return grid.dataItem(row);
        },      
        getSelectedCell: function () {
        	var grid = this.grid;
        	var cell = grid.current();
        	return cell;
        },
        getSelectedCellIndex: function () {
        	var grid = this.grid;
			var cell = grid.current();
			var trazenaCelija = '';		
			if (isset(cell) && cell != null){
				var lockedDio = this.grid.lockedContent;
				var normalDio = this.grid.tbody;	
				if (lockedDio){
					trazenaCelija =	lockedDio.find(cell);
					if (trazenaCelija.length){
						return trazenaCelija.index();						
					}else{
						trazenaCelija = normalDio.find(cell);
						if (trazenaCelija.length){
							return trazenaCelija.index() +  this.getLockedColumnsCount();
						}else{
							return null;
						}
					}
				}else{
					return grid.current().index();
				}
        	}else{
        		return null;
        	}
        },
        getSelectedColumn: function() {  
        	var cell = this.getSelectedCell();
        	var columns = this.grid.columns;
			if (isset(cell) && isset(cell[0])){	
				return columns[	this.getSelectedCellIndex() ]		
			}else{
				return false;
			}
        },
        // https://www.telerik.com/forums/grid-edit-mode-e-container-index-with-locked-column-return-wrong-field
        getLockedColumnsCount: function(){
        	var lockedColumnsCount = 0;
        	var columns = this.grid.columns;
			for(var i=0;i < columns.length; i++){
                if(columns[i].locked){
                  lockedColumnsCount++;
                }
            } 
            return lockedColumnsCount; 		
        },               
        getCheckedData: function () {
        	var grid = this.grid;
        	var rows = grid.tbody.find("tr"); // Tražim rowse
        	
        	var items = [];
        	for (var i = 0; i < rows.length; ++i) {
        		var row = $(rows[i]);
        		var cb = row.find(".row-checkbox");
        		if (cb.length == 1) {
        			if (cb.prop("checked")) {
        				items.push(grid.dataItem(row));
        			}
        		}
        	}
        	return items;
        },
        getCheckedOrSelectedData: function () {
        	var items = $(this.element).kendoKontoGrid("getCheckedData");
        	if (items.length == 0){
        		items.push($(this.element).kendoKontoGrid("getSelectedData"));	
        	}
        	return items;	
        },
        getKeyValues: function () {
        	var grid = this.grid;
        	var keyFields = grid.options.keyFields;
        	var data = $(this.element).kendoKontoGrid("getSelectedData");
        	var values = [];
        	if (data && keyFields) {
        		for (var i = 0; i < keyFields.length; ++i) {
        			values[i] = data[keyFields[i]];
        		}
        	}
        	return values;
        },
        setUrl: function (url) {
        	var opt = this.grid.options;
        	opt.url = url;
        	var ds = this._createDataSource(opt);
        	var dataSource = new kendo.data.DataSource(ds);
        	this.grid.setDataSource(dataSource);
        	this.grid.dataSource.read();
        	//ovo je protrebno zbog ponovog renderanja
        	this._kontoToolbarFiltering();
        },
        setData: function(data) {
        	if (!isset(data) || data == null)
        		var data = [];
        		
        	this.grid.dataSource.data(data);
        },
        getAjaxOption: function (key) {
        	var ds = this.grid.dataSource;
        	return ds.transport.options.read.data[key];
        },
        setAjaxOptions: function (options) {
        	var that = this;
        	$.each(options, function (key, value) {
        		that.setAjaxOption(key, value);
        	});
        },
        setAjaxOption: function (key, value) {
        	var ds = this.grid.dataSource;
        	ds.transport.options.read.data[key] = value;
        },
        removeAjaxOption: function (key) {
        	var ds = this.grid.dataSource;
        	delete ds.transport.options.read.data[key];
        },
        focus: function () {
        	// Nema smisla kad nije visible. 
        	//if (this.isVisible())
        	//	this.grid.table.focus();
        },
        isVisible: function () {
        	return this.grid.table.is(":visible");
        },
        getFilter: function() {
        	return this.grid.dataSource.filter();
        },
        setFilter: function(newFilter) {
        	this.grid.dataSource.filter(newFilter);
        },
        removeFilter: function(field) {
        	var filters = this.getFilter();
        	
        	if (typeof filters === 'undefined')
        		return;
        	
        	var ukloniFilter = function(fields, filter) {
			    for (var i = 0; i < filter.filters.length; i++) {
			
			        // For combination 'and' and 'or', kendo use nested filters so here is recursion
			        if(filter.filters[i].hasOwnProperty('filters')){
			            filter.filters[i] = ukloniFilter (fields, filter.filters[i]);
			            if($.isEmptyObject(filter.filters[i])){
			                filter.filters.splice(i, 1);
			                i--;
			                continue;
			            }
			        }
			
			        // Remove filters
			        if(filter.filters[i].hasOwnProperty('field')){
			            if( fields.indexOf(filter.filters[i].field) > -1){
			                filter.filters.splice(i, 1);
			                i--;
			                continue;
			            }
			        }
			    }
			
			    if(filter.filters.length === 0){
			        filter = {};
			    }
			
			    return filter;
			};
		
        	this.setFilter(ukloniFilter([field],filters));
        	
        },
        
        clearFilter: function() {
        	this.grid.dataSource.filter({});
        }, 
        
        
		/**
		 * Traže se stupci u thead i onda se uzima unutar rowEl stupac s tim indeksom.
		 * Izgleda da su svi stupci prisutni, pa i nevidljivi. Samo što su nevidljivi
		 * označeni s display: none.
		 * Prisutni su i frozen stupci koji su u lockedHeader, a ne vide se u thead 
		 */
		getCell: function (rowEl, columnName) {
            var that = this;
            // tr.first() jer imamo i filter redak
            if (that.grid.lockedHeader){
            	var gridColumnsL = that.grid.lockedHeader.find("tr").first().find("th")
            	var lockedCell = this._getCellFromColumns(rowEl, columnName, gridColumnsL);
            }
            
        	var gridColumnsN = that.grid.thead.find("tr").first().find("th");
        	var normalCell = this._getCellFromColumns(rowEl, columnName, gridColumnsN);	
            
            if (lockedCell){ 
            	return lockedCell;
            }
            return normalCell;           
        },
        
        _getCellFromColumns: function(rowEl, columnName, gridColumns) {
            var colIndex = 0;
            for (var i = 0; i < gridColumns.length; ++i) {
                var th = $(gridColumns[i]);
                var fieldName = th.data("field");
                if (fieldName && (fieldName.toUpperCase() === columnName.toUpperCase())) {
                    var tds = rowEl.find("td");
                    if (tds.length > i) {
                        return $(tds[i]);
                    }
                    break;
                }
            }
            return null;        
        },
        getCellByIndex: function (rowEl, i) {
        	var grid = this.grid;
			var tds = rowEl.find("td");
			
			if (tds.length > i) {
                return $(tds[i]);
       		} else {
           		return false;
           	}
        },
       
        
        /**
         * Vraća header element stupca u kojem se nalazi to polje
         */
        getColumn: function (rowEl, columnName) {
        	var cell = this.getCell(rowEl, columnName);	
        	var columns = this.grid.columns;
        	
        	if (isset(cell[0]))
				return columns[cell[0].cellIndex];
			else
				return false;
        },
        
        options: {   
            // the name is what it will appear as off the kendo namespace(i.e. kendo.ui.MyWidget). 
            // The jQuery plugin would be jQuery.fn.kendoMyWidget.
            name: "KontoGrid",
            // other options go here
            dataSource: null,
     		colModel: null,
     		sortable: {
     			mode: "multiple", 
     			allowUnsort: true
     		},
     		
		    reorderable: {
		        columns: true
		    },
		    columnReorder: function(e) {
					
		        // Ako imamo checkBoxove, njih ne želimo da netko miče (u kendu ješ nema to svojstvo kolone, pa se mora ručno), oni su uvijek na poziciji 0
		        if ((this.options.checkboxSelection == true) && ( (e.oldIndex === 0 || e.newIndex === 0)) ) {
		            var grid = this;
		            setTimeout(function() {
						grid.reorderColumn(e.oldIndex, e.column); //vratimo kolonu di je bila
		            }, 0);
		        }else{
					var uspjelo = KUtils.fixFilterRowColumnsAfterReorder(e);
					
					if (uspjelo == true){
						this.options.remember.columns = true;
						var btnBrisiReorder = this.element.find('button.btn-obrisi-reorder');
						btnBrisiReorder.addClass('active-green');
						if (this.options.reorderTitle){
							this.options.reorderTitle +=  ', ' + e.column.title;
						}else{	
							this.options.reorderTitle = 'Obriši raspored stupaca \n' + e.column.title;
						}	
						btnBrisiReorder.attr('title', this.options.reorderTitle);
					}else{
						//nije uspjelo prebacivanje, vrati nazad kako je bilo
						var grid = this;
			            setTimeout(function() {
							grid.reorderColumn(e.oldIndex, e.column); //vratimo kolonu di je bila
			            }, 0);
					}	
				}				
		    },
		    
     		filterable: {
     			//extra: false,
     			//extra: true, // enablea drugi kriterij
     			mode: "menu, row",
     			messages: {
     				and: "i",
     				or: "ili",
     				filter: "Filtriraj",
     				clear: "Obriši",
     				buttonTitle: "{0} – postavke filtera",
     				info: "Prikaži stavke sa vrijednostima:",
     				isFalse: "nije",
     				isTrue: "je",
     				selectValue: "-Odaberite vrijednost-",
     				cancel: "Izlaz",
     				value: "Vrijednost",
     			},
     			operators: {
     				string: {
     					contains: "Sadrži",
     					startswith: "Počinje sa",
     					eq: "Jednako",
     					neq: "Nije jednako"
     					//doesnotcontain: "Ne sadržava",
     					//endswith: "Završava sa"
     				},
     				number: {
     					eq: "Jednak",
     					neq: "Nije jednak",
     					gte: "Veći ili jednak",
     					gt: "Veći od",
     					lte: "Manji ili jednak",
     					lt: "Manji od"
     				},
     				date: {
     					eq: "Jednak",
     					neq: "Nije jednak",
     					gte: "Veći ili jednak",
     					gt: "Veći od",
     					lte: "Manji ili jednak",
     					lt: "Manji od"
     				}
     			}
     		},
     		selectable: "row",
     		navigatable: true,
     		change: function(e){
     		    try{
         		    var row = this.select();
         		    var dataItem = this.dataItem(row);
         		    var keyFields = this.options.keyFields;
         		    var columnValues = {};
         		    if (dataItem) {
                        for (var i = 0; i < keyFields.length; ++i) {
                            var column = keyFields[i];
                            var val = dataItem[column];
                            if (typeof val == 'object'){
                                try{
                                    val = KUtils.formatDate(val);     
                                } catch (e) {  } 
                            }
                            columnValues[column] = val;
                        }
                    }  
                    if (this.options && this.options.selValues){
                        this.options.selValues.columns = columnValues;
                    }
                    if (e.sender.dataSource.transport.options){
                        e.sender.dataSource.transport.options.read.data.selValues = columnValues;
                    }
                } catch (e) {  }
     		},
     		resizable: true,
     		pageable: {
     			pageSize: 10,
     			pageSizes: [10, 20, 30, 50, 999],
     			refresh: true,
     			messages: {
     				display: "Prikazujem {0} - {1} od {2} stavaka",
     				empty: "Ne postoje stavke",
     				page: "Stranica",
     				of: "od {0}",
     				itemsPerPage: "stavaka po stranici",
     				first: "Na prvu stranicu",
     				last: "Na zadnju stranicu",
     				next: "Na sljedeću stranicu",
     				previous: "Na prethodnu stranicu",
     				refresh: "Osvježi",
     				morePages: "Još stranica",
     			}	
     		},
     		noToolbar: false,
     		toolbarFiltering: true,
     		doAfterNovaNotifikacija: false,
			doAfterNotifikacijaProcitana: false,
     		keyFields: [],
     		export: {
     			exportPDF: false,
     			exportXLS: false,
     			title: "",
     			excludedColumns: ["KORISNIK", "DATUMPROMJENE"]
     		},
     		/**
     		 * Postavke pamćenja:
     		 *   page: pamti se stranica i pageSize
     		 *   sort: pamti se sort
     		 *   filter: pamćenje cjelokupnog filtera. 
     		 *       Ima smisla pamtiti stranicu ako NE pamtimo filter, a zadan je? Skoro sigurno ćemo 
     		 *       se naći na krivoj stranici nakon toga. Čini mi se da bi se u tom slučaju trebala stranica
     		 *       postaviti na 1.
     		 *   currentRecord: pamćenje trenutnog recorda - pozicioniranje neće raditi kad se isključi
     		 */
     		remember: {
     		    page: true,
     		    sort: true,
     		    filter: true,
     		    currentRecord: true,
     		    fullRow: true,
     		    columns: false,
     		},
     		/*
     		 * Koji se parametri koriste kod učitavanja grida
     		 */
     		cacheUsage: {
     		    page: true,
     		    sort: true,
     		    filter: true,
     		    currentRecord: true,
     		    fullRow: true,
     		    columns: true  
     		},
     		datasnapResponse: function (response) {
     			
     		},
     		/**
     		 * Označava lokalno filtriranje i sortiranje
     		 */
     		localData: false
        }              
    });
       
    ui.plugin(KontoGrid);
    
   
    
})(jQuery);